import { useMemo, useContext, useState, useEffect } from "react";
import { ABTestingContext } from "./context.js";
import { transformMonetateResponse } from "../lib/utils.js";
function useABTest(testName) {
  const allABTests = useActiveABTests();
  return useMemo(() => {
    var _a;
    const abTest = allABTests == null ? void 0 : allABTests.find((exp) => {
      var _a2;
      return ((_a2 = exp.json) == null ? void 0 : _a2.test_name) === testName;
    });
    const testValue = (_a = abTest == null ? void 0 : abTest.json) == null ? void 0 : _a.test_variant;
    return testValue;
  }, [allABTests]);
}
function useActiveABTests() {
  const context = useContext(ABTestingContext);
  const monetateData = context == null ? void 0 : context.monetateData;
  if (!monetateData)
    throw "Please wrap your component in <ABTestingProvider /> in order to use this hook.";
  const [activeABTests, setActiveABTests] = useState();
  useEffect(() => {
    if (monetateData.data) {
      const abTests = transformMonetateResponse(monetateData);
      setActiveABTests(abTests);
    }
  }, [monetateData]);
  return activeABTests;
}
export {
  useABTest,
  useActiveABTests
};
//# sourceMappingURL=hooks.js.map
